import styled from 'styled-components';

import CheckboxButton from 'components/commons/CheckboxButton';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
`;

export const TermFilterValue = styled.span`
  margin-left: 8px;
  font-size: 12px;
  line-height: 16px;
  color: #474747;
`;

export const TermFilterItem = styled(CheckboxButton)`
  margin: 8px 8px 0 0;

  &:disabled {
    ${TermFilterValue} {
      color: #ececec;
    }
  }
`;
